module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/296.16db0de8.png";